import React from 'react';

const PrimaryButton = ({ label, onClick, type = "submit", disabled = false }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`bg-orange-500 text-white font-semibold p-[12px] rounded-full w-full mb-2 
                  hover:bg-orange-600 focus:outline-none focus:bg-orange-600 
                  ${disabled ? 'disabled:opacity-50 disabled:pointer-events-none' : ''}`}
    >
      {label}
    </button>
  );
};

export default PrimaryButton;
